import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Moon, Sun, Menu, X } from 'lucide-react';
import { useTheme } from '../components/ThemeProvider';
import LogoHorizontal from '../assets/icon-512.png';
import LogoIcon from '../assets/icon-64.png';

const Header = () => {
  const { isDarkMode, toggleDarkMode } = useTheme();
  const [isMenuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!isMenuOpen);

  return (
    <header className="sticky top-0 z-50 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center justify-center gap-3" aria-label="Go to CognitAIX Homepage" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <picture>
              <source srcSet={LogoIcon} media="(max-width: 768px)" />
              <img
                src={LogoHorizontal}
                alt="CognitAIX - AI-powered Data Solutions Logo"
                className="h-12"
                style={{ marginRight: '4px' }} // Add some spacing between logo and text
              />
            </picture>
            <span style={{ color: '#3399ff',  fontFamily: 'PT sans' , fontSize: 30, fontWeight:'bold' }}>
              CognitAIX
            </span>
          </Link>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            <Link
              to="/"
              className="text-gray-700 dark:text-gray-200 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300"
              aria-label="Navigate to Home"
            >
              Home
            </Link>
            <Link
              to="/solutions"
              className="text-gray-700 dark:text-gray-200 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300"
              aria-label="Navigate to Solutions"
            >
              Solutions
            </Link>
            <Link
              to="/webaiexcel"
              className="text-gray-700 dark:text-gray-200 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300"
              aria-label="Navigate to WebAIExcel Deomo Page"
            >
              WebAIExcel
            </Link>
            <Link
              to="/blogs"
              className="text-gray-700 dark:text-gray-200 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300"
              aria-label="Navigate to Blog Deomo Page"
            >
              Blogs
            </Link>            
            {/*
            <Link
              to="/playground"
              className="text-gray-700 dark:text-gray-200 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300"
              aria-label="Navigate to Playground"
            >
              Playground
            </Link>
            {/*
            <Link
              to="/portal"
              className="text-gray-700 dark:text-gray-200 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300"
              aria-label="Navigate to Portal"
            >
              Portal
            </Link>
            */}
            <Link
              to="/contact"
              className="text-gray-700 dark:text-gray-200 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300"
              aria-label="Navigate to Contact"
            >
              Contact
            </Link>
            <button
              onClick={toggleDarkMode}
              className="p-2 rounded-full border-2 border-gray-300 dark:border-gray-600 hover:border-brandPurple dark:hover:border-brandBlue bg-gray-100 dark:bg-gray-700 transition-all duration-300"
              aria-label="Toggle theme"
            >
              {isDarkMode ? (
                <Sun size={20} className="text-gray-700 dark:text-gray-300" />
              ) : (
                <Moon size={20} className="text-gray-700 dark:text-gray-300" />
              )}
            </button>
          </nav>

          {/* Mobile Hamburger Menu */}
          <button
            onClick={toggleMenu}
            className="md:hidden p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-brandPurple dark:focus:ring-brandBlue"
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <nav className="md:hidden bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 py-4">
          <ul className="space-y-4 px-4">
            <li>
              <Link
                to="/"
                className="block text-gray-700 dark:text-gray-200 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300"
                onClick={toggleMenu}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/solutions"
                className="block text-gray-700 dark:text-gray-200 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300"
                onClick={toggleMenu}
              >
                Solutions
              </Link>
            </li>
            <li>
              <Link
                to="/webaiexcel"
                className="block text-gray-700 dark:text-gray-200 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300"
                onClick={toggleMenu}
              >
                WebAIExcel
              </Link>
            </li>
            <li>
              <Link
                to="/blogs"
                className="block text-gray-700 dark:text-gray-200 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300"
                onClick={toggleMenu}
              >
                Blogs
              </Link>
            </li>
            {/*
            <li>
              <Link
                to="/playground"
                className="block text-gray-700 dark:text-gray-200 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300"
                onClick={toggleMenu}
              >
                Playground
              </Link>
            </li>
            <li>
              <Link
                to="/portal"
                className="block text-gray-700 dark:text-gray-200 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300"
                onClick={toggleMenu}
              >
                Portal
              </Link>
            </li>
            */}
            <li>
              <Link
                to="/contact"
                className="block text-gray-700 dark:text-gray-200 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300"
                onClick={toggleMenu}
              >
                Contact
              </Link>
            </li>
            <li>
              <button
                onClick={() => {
                  toggleDarkMode();
                  toggleMenu();
                }}
                className="block w-full text-left text-gray-700 dark:text-gray-200 hover:text-brandPurple dark:hover:text-brandBlue transition-colors duration-300"
              >
                {isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
              </button>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
};

export default Header;
